var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cloud-animation-container"},_vm._l((_vm.clouds),function(cloud,index){return _c('div',{key:`cloud-${index}`,staticClass:"cloud",style:({
            top: cloud.top + '%',
            animationDelay: cloud.delay + 's',
            animationDuration: cloud.duration + 's',
        })},[_c('div',{staticClass:"cloud-body"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }